import { Component, OnInit } from '@angular/core';

import { Destino } from "../shared/destino.model";
import { destinosModuleName } from "../shared/data.service";
import { DestinoApiService } from "../shared/destino-api.service";
import { DestinoNavigationService } from "../shared/destino-navigation.service";
import { DestinoService } from "../shared/destino.service";
import { ViagemService } from "../../shared/viagem.service";
import { configuracaoModuleName } from "../../../shared/services/data.service";
import { viagensModuleName} from "../../shared/data.service";
import { UtilService } from "../../../shared/services/util.service";

@Component({
    template: require('./destino-list.component.html'),
    styles: [require('./destino-list.component.css')]
})
export class DestinoListComponent implements OnInit {
    list: Destino[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    destinosModuleName: any = destinosModuleName;
    configuracaoModule: any = configuracaoModuleName;
    module: any = viagensModuleName;

    constructor(
        private _destinosApiService: DestinoApiService,
        private _destinoNavigationService: DestinoNavigationService,
        private _destinoService: DestinoService,
        private _viagemService: ViagemService,
        private _utilService: UtilService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickGoToConfig() {
        this._viagemService.goToSetting()
    }

    clickNew() {
        this._destinoService.clearSessionStorage();
        this._destinoNavigationService.goToNew();
    }

    clickEdit(item: Destino) {
        this._destinoService.clearSessionStorage();
        this._destinoNavigationService.goToEdit(item.id);
    }

    clickDelete(item: Destino) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._destinosApiService.onGetAll(onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._destinosApiService.onDelete(item.id, onDone);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/destinos/destino-list/destino-list.component.ts
 **/